import React from 'react';

export const MainLayoutLeftNavigationTopLogo = ({ isShow }: { isShow: boolean }) => <div />;
export const ErrorPageOrganization = (lang?: string) => (lang === 'ru' ? '© ООО «Антифишинг»,' : '© Human Factor, LLC');
export const isShowOnlyEmail = () => false;
